
import { Union } from "../../fable-library-js.5.13.0/Types.js";
import { list_type, class_type, string_type, union_type } from "../../fable-library-js.5.13.0/Reflection.js";
import { Common_GenericOptions__AddModifiers_Z7C3AFA3, Common_GenericOptions__AddProps_Z4E55E0BD, Common_GenericOptions__AddClass_Z721C83C5, Common_GenericOptions_Parse_Z4D1A7726, Common_GenericOptions__ToReactElement_4509C2D7, Reflection_getCaseName, Modifier_IModifier_$reflection, Screen_$reflection } from "../Common.fs.js";
import * as react from "react";
import { keyValueList } from "../../fable-library-js.5.13.0/MapUtil.js";

export class ISize extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["is-one-quarter", "is-one-third", "is-half", "is-two-thirds", "is-three-quarters", "is-1", "is-2", "is-3", "is-4", "is-5", "is-6", "is-7", "is-8", "is-9", "is-10", "is-11", "is-12", "is-narrow", "is-full", "is-one-fifth", "is-two-fifths", "is-three-fifths", "is-four-fifths"];
    }
    static IsOneQuarter = new ISize(0, []);
    static IsOneThird = new ISize(1, []);
    static IsHalf = new ISize(2, []);
    static IsTwoThirds = new ISize(3, []);
    static IsThreeQuarters = new ISize(4, []);
    static Is1 = new ISize(5, []);
    static Is2 = new ISize(6, []);
    static Is3 = new ISize(7, []);
    static Is4 = new ISize(8, []);
    static Is5 = new ISize(9, []);
    static Is6 = new ISize(10, []);
    static Is7 = new ISize(11, []);
    static Is8 = new ISize(12, []);
    static Is9 = new ISize(13, []);
    static Is10 = new ISize(14, []);
    static Is11 = new ISize(15, []);
    static Is12 = new ISize(16, []);
    static IsNarrow = new ISize(17, []);
    static IsFull = new ISize(18, []);
    static IsOneFifth = new ISize(19, []);
    static IsTwoFifths = new ISize(20, []);
    static IsThreeFifths = new ISize(21, []);
    static IsFourFifths = new ISize(22, []);
}

export function ISize_$reflection() {
    return union_type("Fulma.Column.ISize", [], ISize, () => [[], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], []]);
}

export class Option extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Width", "Offset", "CustomClass", "Props", "Modifiers"];
    }
}

export function Option_$reflection() {
    return union_type("Fulma.Column.Option", [], Option, () => [[["Item1", Screen_$reflection()], ["Item2", ISize_$reflection()]], [["Item1", Screen_$reflection()], ["Item2", ISize_$reflection()]], [["Item", string_type]], [["Item", list_type(class_type("Fable.React.IHTMLProp"))]], [["Item", list_type(Modifier_IModifier_$reflection())]]]);
}

function suffix(_arg) {
    switch (_arg.tag) {
        case 1:
            return "-desktop";
        case 2:
            return "-tablet";
        case 3:
            return "-mobile";
        case 4:
            return "-widescreen";
        case 6:
            return "-fullhd";
        case 5:
            return "-touch";
        default:
            return "";
    }
}

export function ofWidth(screen, size) {
    return Reflection_getCaseName(size) + suffix(screen);
}

export function ofOffset(screen, offset) {
    const className = Reflection_getCaseName(offset);
    return ("is-offset-" + className.slice(3, className.length)) + suffix(screen);
}

/**
 * Generate <div class="column"></div>
 */
export function column(options, children) {
    return Common_GenericOptions__ToReactElement_4509C2D7(Common_GenericOptions_Parse_Z4D1A7726(options, (result, option) => {
        switch (option.tag) {
            case 1:
                return Common_GenericOptions__AddClass_Z721C83C5(result, ofOffset(option.fields[0], option.fields[1]));
            case 2:
                return Common_GenericOptions__AddClass_Z721C83C5(result, option.fields[0]);
            case 3:
                return Common_GenericOptions__AddProps_Z4E55E0BD(result, option.fields[0]);
            case 4:
                return Common_GenericOptions__AddModifiers_Z7C3AFA3(result, option.fields[0]);
            default:
                return Common_GenericOptions__AddClass_Z721C83C5(result, ofWidth(option.fields[0], option.fields[1]));
        }
    }, "column"), (props_1, children_1) => react.createElement("div", keyValueList(props_1, 1), ...children_1), children);
}

